import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../../../common/mapper";

export default class ReceivingGiftSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { dataCabang, searchValue, onSearchChange, onSubmit, onFilterClick } =
      this.props;
    return (
      <React.Fragment>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang)
              )}
              value={searchValue.kodeCabang}
              onChange={(value, { name }) => onSearchChange(name, value)}
            />
            <SimpleDate
              id="select_date_from"
              nextdate
              date={searchValue.spbhStartDate}
              maxDate={searchValue.spbhEndDate}
              onChange={(value) =>
                onSearchChange(
                  "spbhStartDate",
                  moment(value).format("DD-MM-YYYY")
                )
              }
            />
            <SimpleDate
              id="select_date_to"
              date={searchValue.spbhEndDate}
              onChange={(value) =>
                onSearchChange(
                  "spbhEndDate",
                  moment(value).format("DD-MM-YYYY")
                )
              }
            />
            <SimpleButton
              text="Cari"
              className="margin-bottom-20px"
              onClick={onSubmit}
            />
          </FlexView>
          <SimpleButton
            className={"btn background-red margin-bottom-20px"}
            styles={{ width: "unset" }}
            onClick={onFilterClick}
            icon={<i className="fa fa-qrcode"></i>}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
